import { TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import { toast } from "react-toastify";

let userToken = localStorage.getItem("userToken");

export default function EditFAQ({
  itemToEdit,
  setItemToEdit,
  data,
  setData,
  refresh,
  setRefresh,
  endpoint,
}) {
  const [input, setInput] = useState({ q: "", a: "" });
  let userToken = localStorage.getItem("userToken");

  const ref = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setItemToEdit({});
      setInput({ q: "", a: "" });
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (Object.keys(itemToEdit).length > 0) {
      setInput({
        q: data[itemToEdit.index]?.faqs[itemToEdit.indexx]?.q,
        a: data[itemToEdit.index]?.faqs[itemToEdit.indexx]?.a,
      });
    }
  }, [itemToEdit]);

  const updateData = async () => {
    if (input.q.length > 0 && input.a.length > 0) {
      let tempData = [...data];
      tempData[itemToEdit.index].faqs[itemToEdit.indexx] = { q: input.q, a: input.a };
      setData(tempData);

      await fetch(`${API}/${endpoint}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: endpoint == "partnership" ? { faq: tempData } : { contactData: tempData },
        }),
      }).then((res) => {
        if (res.ok) {
          toast.success("FAQ Updated Successfully!");
          setRefresh(!refresh);
          setItemToEdit({});
          setInput({ q: "", a: "" });
        } else {
          toast.error("Failed to Update FAQ!");
        }
      });
    } else {
      toast.error("Please fill all the fields!");
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#00000020",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: 99999999,
        top: 0,
        left: 0,
        opacity: Object.keys(itemToEdit).length > 0 ? 1 : 0,
        visibility: Object.keys(itemToEdit).length > 0 ? "visible" : "hidden",
        transition: "0.3s",
      }}
      className="flex">
      <div
        ref={ref}
        style={{
          width: "70%",
          width: 600,
          height: "auto",
          backgroundColor: "#fff",
          borderRadius: 15,
          transition: "0.3s",
          padding: "4rem 2rem",
        }}>
        <div
          className="fadeInFast"
          style={{
            marginTop: 10,
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            transition: "0.3s",
          }}>
          {Object.keys(itemToEdit).length > 0 && (
            <>
              <TextField
                label="Question"
                sx={{ width: "90%" }}
                value={input.q}
                onChange={(e) => {
                  setInput({ ...input, q: e.target.value });
                }}
              />
              <TextField
                label="Answer"
                sx={{ width: "90%", mt: 2, mb: 2 }}
                multiline
                rows={6}
                value={input.a}
                onChange={(e) => {
                  setInput({ ...input, a: e.target.value });
                }}
              />
            </>
          )}
        </div>

        <div className="submitBTN" style={{ margin: "0 auto", marginTop: 0 }} onClick={updateData}>
          Save Changes
        </div>
      </div>
    </div>
  );
}
